import { getByPath, isObject, ObjectToDotNotation, dotNotationToObject } from '@/utils'
import { path as ramdaPath } from 'ramda'

function arrayToObject(arr) {
  if (!(arr instanceof Array)) return
  return arr.reduce((obj, item) => {
    const key = Object.keys(item)[0]
    const value = Object.values(item)[0]

    return Object.assign(obj, { [key]: value })
  }, {})
}

//schema = customFieldsSchema
function findConfig(key, schema) {
  if (!(schema instanceof Array)) return

  let result
  schema.forEach(s => {
    if (s.key === key) return (result = s)
    if (!result) {
      result = findConfig(key, s.component)
    }
  })
  return result
}

function mapKey(component, data) {
  if (component.component instanceof Array) {
    return {
      [component.key]: arrayToObject(
        component.component
          .map(i => {
            const options = {
              ...component,
              ...i,
            }

            const dataKey = options.dataKey ? `${options.dataKey}.${i.key}` : ''
            return mapKey({ ...i, dataKey }, data)
          })
          .flat(),
      ),
    }
  }

  return { [component.key]: getByPath((component.dataKey || component.key).replaceAll('-', '.'), data) }
}

// Result
// {'basis-address': {cadastre: '5453/554/5435/43/54'}}
function getFieldsValues(schemas, data) {
  let result = []
  //map keys with '-'
  result = schemas
    .filter(i => i.component instanceof Array && !i.isCustom && i.key.includes('-'))
    .map(i => {
      return {
        [i.key]: arrayToObject(
          i.component
            .filter(c => c.component !== 'Slot')
            .map(c => mapKey(c, data))
            .filter(Boolean)
            .flat(),
        ),
      }
    })

  return arrayToObject(result.flat())
}

// Result
// {'address': {cadastre: '5453/554/5435/43/54'}}
function setFieldsValue(item, schemas = []) {
  if (!isObject(item)) return
  //convert object to dotnotation

  const items = Object.entries(ObjectToDotNotation(item))

  const result = Object.fromEntries(
    items
      .map(([path, value]) => {
        if (path.includes('customFields')) {
          return [path, value]
        }
        //convert the key to array
        let key = path.split('.')

        if (!key) return

        //transform key based on config from cf schemas
        if (key instanceof Array) {
          //skip paths whose leading segment isn't a managed schema field (e.g.
          //`basePrice`, a hidden customFields snapshot spread to the top level).
          //Without this, the segment gets shifted off and a nested key like
          //`basePrice.sale` collides with the built-in `sale` field and overwrites it.
          //Their canonical values are preserved via the `customFields.*` branch above.
          let config = findConfig(key[0], schemas)
          if (!config) return []

          if (config && ramdaPath(['dataKey'], config) && config.dataKey === 'customFields') {
            key = [config.dataKey, ...key]
          } else {
            //handler for fields that is saved under data
            key.shift()

            let field = key[0]
            if (!field) return []

            config = findConfig(field, schemas)

            //search for config one deeper
            if (!ramdaPath(['dataKey'], config)) {
              config = findConfig(key[key.length - 1], schemas)
            }

            if (config && config.dataKey) {
              if (config.dataKey === 'customFields') {
                return []
              }
              key.splice(0, 1, config.dataKey)
            }
          }
        }

        return [key.join('.'), value]
      })
      .filter(i => {
        return i && i.length
      }),
  )

  return dotNotationToObject(result)
}

export { arrayToObject, getFieldsValues, setFieldsValue }
